import { useEffect, useState } from "react";
// import httpClient from "../HTTPService";
import httpClient from "../../../HTTPService";
import { Tooltip as ReactTooltip } from "react-tooltip";

import moment from "moment";

function TotalDistrubution() {
  const [rportsList, setReportslist] = useState([])
  const [searchtext, setsearchtext] = useState('')
  const [totalCount, setTotalCount] = useState(0)
  const [currentPage, setCurrentPage] = useState(1);
  const [totalDistribution, setTotalDistribution] = useState(0)
  const [getLimit, setLimit] = useState(10);
  const items = Array.from({ length: totalCount }, (_, index) => `Item ${index + 1}`);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(items.length / getLimit);
  const startPage = Math.max(1, currentPage - Math.floor(5 / 2));
  const endPage = Math.min(totalPages, currentPage + Math.floor(5 / 2));
  useEffect(() => {
    fetchapproavedlistdata(searchtext, currentPage, getLimit);
  }, [currentPage, getLimit]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  //search button

  const searchtxt = () => {
    fetchapproavedlistdata(searchtext, 1, getLimit);
  }
  //pagiantion

  const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    console.log(currentPage, 'current pages...')
    return (
      <div className="pagination">
        {currentPage > 1 && (
          <button className="pagination-btn" onClick={() => onPageChange(currentPage - 1)}>
            <i className="fa fa-chevron-left" aria-hidden="true"></i>
          </button>
        )}
        {startPage > 1 && (
          <button className="pagination-btn" onClick={() => onPageChange(1)}>
            1
          </button>
        )}
        {startPage > 2 && <span className="pagination-ellipsis">...</span>}
        {pages.slice(startPage - 1, endPage).map(page => (
          <button
            key={page}
            className={`pagination-btn ${page === currentPage ? 'active' : ''}`}
            onClick={() => onPageChange(page)}
          >
            {page}
          </button>
        ))}
        {endPage < totalPages - 1 && <span className="pagination-ellipsis">...</span>}
        {endPage < totalPages && (
          <button className="pagination-btn" onClick={() => onPageChange(totalPages)}>
            {totalPages}
          </button>
        )}
        {currentPage < totalPages && (
          <button className="pagination-btn" onClick={() => onPageChange(currentPage + 1)}>
            <i className="fa fa-chevron-right" aria-hidden="true"></i>
          </button>
        )}
      </div>
    );
  };
  // get reports


  const fetchapproavedlistdata = async (search_name, pagecount, limit) => {
    try {
      const result = await httpClient.post("/admin/withdraw-list", {
        search_name, search_status: 1,

        offset: pagecount, limit: limit
      }, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      console.log(result.data.data);
      if (result.data.status == true) {
        setTotalCount(result?.data.total_count)
        setReportslist(result?.data?.data)
        setTotalDistribution(result?.data?.total_distribution_amount)
        // location.state = null
        // toast.success(result.data.message)
      }
      if (result.data.status == false) {
        // toast.error(result.data.message)

      }

    }

    catch (error) {
      // toast.error(error.message)
    }
  }

   // debounce function to limit the number of API calss
  function debounce(func, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), delay);
    };
  }
  // search handler function
  const searchHandler = debounce((query) => {
    setsearchtext(query);
    fetchapproavedlistdata(query, 1, getLimit);
  }, 2000)

  return (
    <>
      <div className="">
        <div class="search-box">
          <div class="searchtct">

            <i class="fa fa-search" aria-hidden="true"></i>
            <input type="text" name="text" placeholder="Search..."
              onChange={(val) => searchHandler(val.target.value ,currentPage,getLimit)}

            />
            <button type='button' className='searchBtn' onClick={searchtxt} >Search</button>


          </div>

        </div>
        <div class="row">
          <div class="col-md-12">
            <h5>Distribution Done Total: ₹{totalDistribution} </h5>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>SL NO</th>
                    <th> Member Name & ID</th>
                    <th>Account Holder Name</th>
                    <th>Date & Time</th>
                    <th>TO Account</th>
                    <th>Amount(₹)</th>

                  </tr>
                </thead>
                <tbody>

                  {
                    rportsList?.map((item, index) => {
                      const serialNumber = (currentPage - 1) * getLimit + index + 1;

                      return (
                        <tr>
                          <td style={{
                            backgroundColor: item?.user?.phone == null ? 'gray' : 'transparent',
                            color: item?.user?.phone == null ? 'white' : 'black'
                          }}>{serialNumber}</td>
                          <td style={{
                            backgroundColor: item?.user?.phone == null ? 'gray' : 'transparent',
                            color: item?.user?.phone == null ? 'white' : 'black'
                          }}>{
                              <div style={{
                                display: 'flex',
                                flexDirection: 'column'
                              }}>
                                <p>{item?.user?.name} </p>
                                <p>{item?.user?.user_referral_code}</p>
                              </div>



                            }</td>
                          <td style={{
                            backgroundColor: item?.user?.phone == null ? 'gray' : 'transparent',
                            color: item?.user?.phone == null ? 'white' : 'black'
                          }}>

                            {item?.account_holder_name}
                          </td>
                          <td style={{
                            backgroundColor: item?.user?.phone == null ? 'gray' : 'transparent',
                            color: item?.user?.phone == null ? 'white' : 'black'
                          }}>
                            <p>{moment(item?.approved_date).format('DD/MM/YYYY')}</p>
                            <p>{moment(item?.approved_date).format('LT')}</p>
                          </td>
                          <td style={{
                            backgroundColor: item?.user?.phone == null ? 'gray' : 'transparent',
                            color: item?.user?.phone == null ? 'white' : 'black'
                          }}>{item?.account_no}</td>

                          <td style={{
                            backgroundColor: item?.user?.phone == null ? 'gray' : 'transparent',
                            color: item?.user?.phone == null ? 'white' : 'black'
                          }}>{item?.amount}</td>


                        </tr>
                      )
                    })
                  }
                </tbody>
              </table>
              <div className='nodata-found-div'>
                {
                  rportsList?.length == 0 ?
                    <p>No Data Found</p>
                    //  <img 
                    //  className='table-image'
                    //  src={require('../../assets/OIP.png')}/>
                    : null
                }
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="table-responsive">
                    <table class="table" style={{
                      backgroundColor: '#FFFFFF'
                    }}>
                      <tbody>
                        <tr>
                          {/* <th className="col-1"></th> */}
                          <td className="col-1"  > </td>
                          <td className="col-1"  >     </td>
                          <td className="col-1" style={{
                            textAlign: 'start'
                          }} >


                          </td>
                          {/* <td className="col-1"></td> */}
                          <td className="col-1">

                          </td>
                          <td className="col-1"> </td>
                          <td className="col-1"></td>
                          <td className="col-1">Total: {totalDistribution}</td>


                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div class="row total_amount_display">
          <div class="col-md-8">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>SL NO</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
        </div> */}
        <div class="tablepgntn">
          <p>Show <select value={getLimit} onChange={(val) => {
            setLimit(val.target.value);
            setCurrentPage(1)
          }}>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={30}>30</option>
            <option value={40}>40</option>
            <option value={50}>50</option>
          </select> Entries</p>
          <ul>

          </ul>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />

        </div>

      </div>

    </>
  )
}
export default TotalDistrubution